import { Box, TextField, FormControlLabel, Checkbox } from '@mui/material'
import { REQUESTS_HEADER_STRINGS } from './strings'

interface RequestsHeaderProps {
  search: string
  setSearch: (value: string) => void
  hideClosed: boolean
  setHideClosed: (value: boolean) => void
}

export const RequestsHeader = ({
  search,
  setSearch,
  hideClosed,
  setHideClosed,
}: RequestsHeaderProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          fullWidth
          placeholder={REQUESTS_HEADER_STRINGS.searchPlaceholder}
          value={search}
          onChange={e => setSearch(e.target.value)}
          size="small"
          sx={{
            backgroundColor: 'background.default',
            borderRadius: 28,
            '.MuiOutlinedInput-root': {
              borderRadius: 28,
              fontSize: 17,
              px: 1.5,
              py: 1.25,
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              boxShadow: 'none',
            },
            flex: 1,
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          component="h1"
          sx={{ fontSize: 40, fontWeight: 500, lineHeight: 'normal', m: 0, color: 'text.primary' }}
        >
          {REQUESTS_HEADER_STRINGS.title}
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={hideClosed}
              onChange={e => setHideClosed(e.target.checked)}
              sx={{ ml: 3 }}
            />
          }
          label={REQUESTS_HEADER_STRINGS.hideClosed}
          sx={{
            ml: 3,
            mr: 0,
            whiteSpace: 'nowrap',
            '.MuiFormControlLabel-label': { fontSize: 16 },
          }}
        />
      </Box>
    </Box>
  )
}
